import { clientEnv } from '@/shared/config/env';

export interface MonitoringEvent {
  context?: Record<string, unknown>;
  event: string;
  level?: 'debug' | 'info' | 'warn' | 'error';
}

export const reportEvent = (event: MonitoringEvent) => {
  if (!clientEnv.enableDebug && event.level === 'debug') return;

  if (clientEnv.enableDebug) {
    console.info('[monitoring]', event.event, event.context ?? {});
  }
};
